import './style.scss'
import MasterCard from '../../assets/masterCard.svg';
import visaCard from '../../assets/visacard.svg';
import paymentCard3 from '../../assets/paymentCard3.svg';
import paymentCard4 from '../../assets/paymentCard4.svg';
import paymentCard5 from '../../assets/paymentCard4.svg';
import LazyImage from '../LazyImage';

const BrainTree = () => {
    return (
        <div className="braintree-form-container">
            <div className='braintree-header'>
                <div className="braintree-sheet-header-label">
                    <div className="braintree-sheet-logo-header">
                        <svg width="40" height="24" className="braintree-icon--bordered">
                            <use href="#iconCardFront"></use>
                        </svg>
                    </div>
                    <div className="braintree-sheet__text">Pay with card</div>
                </div>
                <div className="logo-container">
                    <span aria-hidden="true" className="logo">
                        <LazyImage imgSrc={MasterCard} />
                    </span>
                    <span aria-hidden="true" className="logo">
                        <LazyImage imgSrc={visaCard} />
                    </span>
                    <span aria-hidden="true" className="logo">
                        <LazyImage imgSrc={paymentCard3} />
                    </span>
                    <span aria-hidden="true" className="logo">
                        <LazyImage imgSrc={paymentCard4} />
                    </span>
                    <span aria-hidden="true" className="logo">
                        <LazyImage imgSrc={paymentCard5} />
                    </span>
                </div>

            </div>
            <hr />
            <div className="form-group">
                <p className="form-label">Cardholder Name</p>
                <input type="text" id="cardholderName" placeholder='Cardholder Name' disabled={true} name="cardholderName" className="form-input" required />
            </div>
            <div className="form-group">
                <p className="form-label">Card Number</p>
                <input type="text" id="cardNumber" placeholder="•••• •••• •••• ••••" disabled={true} name="cardNumber" className="form-input" required />
            </div>
            <div className='braintree-footer'>
                <div className="form-group">
                    <p className="form-label">Expiration Date</p>
                    <input type="text" id="expirationDate" disabled={true} placeholder='MM/YY' name="expirationDate" className="form-input" required />
                </div>
                <div className="form-group">
                    <p className="form-label">CVV</p>
                    <input type="text" id="cvv" name="cvv" disabled={true} placeholder='•••' className="form-input" required />
                </div>
            </div>
        </div>
    )
}

export default BrainTree